import { useRef } from 'react'
import { MapListFilters, MapOwnerFilter } from 'features/maps/types'
import BasicPageFilterBar from 'features/common/ui/BasicPage/Partials/BasicPageFilterBar'

import MapsOrderSelector from './MapsOrderSelector'
import MapsSearchBar from './MapsSearchBar'
import MapsClearSearch from './MapsClearSearch'
import { useMeUser } from 'features/users/hooks/useMeUser'
import { isGuest } from 'features/users/model/user'
import { FilterInputRefProps } from 'features/common/ui/Forms/FilterInput/FilterInput'
import { FeatureFlag, useFeatureFlag } from 'app/ui/useFeatureFlag'
import TagFilterSelector from 'features/tags/ui/TagFilterSelector'
import MapsFilterOwnerSelector from './MapsFilterOwnerSelector'

interface Props {
  total: number
  filters: MapListFilters
  onChange(partial: Partial<MapListFilters>): void
}

function MapsFilter({ filters, onChange, total }: Props) {
  const ref = useRef<FilterInputRefProps>(null)
  const hasTagsForResourcesEnabled = useFeatureFlag(FeatureFlag.TagsForResources)

  const user = useMeUser()
  const userIsGuest = isGuest(user)

  const clear = () => {
    onChange({ search: '' })
    if (ref.current) {
      ref.current.clear()
    }
  }

  const hasActiveFilters = Boolean(
    filters.search || filters.permissions !== MapOwnerFilter.All || (filters.tags && filters.tags.length > 0)
  )
  return (
    <BasicPageFilterBar
      clearResults={
        hasActiveFilters && filters.search && <MapsClearSearch total={total} search={filters.search} onClear={clear} />
      }
    >
      <MapsSearchBar ref={ref} initialValue={filters.search} onSearchChange={(search) => onChange({ search })} />
      {!userIsGuest && (
        <>
          {hasTagsForResourcesEnabled && (
            <TagFilterSelector value={filters.tags} onFilterChange={(tags) => onChange({ tags })} />
          )}
          <MapsFilterOwnerSelector
            onFilterChange={(filter) => onChange({ permissions: filter })}
            value={filters.permissions}
          />
        </>
      )}
      <MapsOrderSelector order={filters.order} onOrderChange={(order) => onChange({ order })} />
    </BasicPageFilterBar>
  )
}

export default MapsFilter
